export default {
  title: 'Gift Cards',
  page_title: 'Gift Cards | Thanx',
  description:
    'Configure and manage your gift card program to drive new customers and increase revenue.',
  configuration: {
    title: 'Configuration',
  },
  card_image: {
    title: 'Card image',
    description:
      'Personalize your gift card design so it feels like part of your brand and delights your customers.',
    default_option: 'Default card image',
    default_subtext:
      'Automatically generates a card with your logo and chosen brand color.',
    custom_option: 'Custom card image',
    custom_subtext:
      'Upload a card image in the required dimensions for a unique design.',
    badges: {
      app_web: 'App & Web',
      resolution: '1372PX X 860PX',
      jpg: 'JPG',
      png: 'PNG',
      gif: 'GIF',
    },
  },
  card_color: {
    label: 'Card background color',
  },
  external_link: {
    title: 'Add external link for gift cards',
    description:
      'When configured, customers will see a section at the bottom of the Gift Cards page that can link to a page of your choice (e.g. buy a physical gift card, gift to a friend, etc)',
    yes: 'Yes',
    no: 'No',
    recommended: 'Recommended',
    link_image: {
      title: 'Link image',
      badges: {
        app_only: 'App Only',
        width: '1800PX WIDE',
        height: 'ANY HEIGHT',
        jpg: 'JPG',
        png: 'PNG',
      },
    },
    link_url: {
      title: 'Where should this image link to?',
    },
  },
  publish: 'Publish',
  info_panel: {
    ready_title: 'Ready to go live?',
    ready_description:
      'Hit the "Publish" button to save changes and push them to your app or website.',
  },
  alert_success: 'Gift card configuration published successfully.',
  alert_fail: 'Failed to publish gift card configuration. Please try again.',
  alert_custom_image_missing:
    'Please upload a custom card image before publishing.',
  alert_external_link_image_missing:
    'Please upload an external link image before publishing.',
  empty_state: {
    title: 'Bring gift cards to checkout with Valutec',
    subtitle:
      'Enable guests to store and redeem their gift cards directly at checkout — no manual entry or PINs required. Thanx integrates seamlessly with Valutec, allowing guests to:',
    once_connected:
      'Once connected, you can configure your gift card image and settings to deliver a fully branded experience.',
    info_section: {
      title: 'Add gift cards to your app',
      subtitle:
        'Interested in offering gift cards? Contact us to enable Valutec integration or reach out if you have any questions.',
      learn_button: 'Learn how to set up gift cards',
      contact_button: 'Contact us',
    },
  },
}
